var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.31185V2.47852H15V8.31185",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 15.8125H3.33366C2.89163 15.8125 2.46771 15.6369 2.15515 15.3243C1.84259 15.0118 1.66699 14.5879 1.66699 14.1458V9.97917C1.66699 9.53714 1.84259 9.11322 2.15515 8.80066C2.46771 8.4881 2.89163 8.3125 3.33366 8.3125H16.667C17.109 8.3125 17.5329 8.4881 17.8455 8.80066C18.1581 9.11322 18.3337 9.53714 18.3337 9.97917V14.1458C18.3337 14.5879 18.1581 15.0118 17.8455 15.3243C17.5329 15.6369 17.109 15.8125 16.667 15.8125H15.0003",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4785H5V19.1452H15V12.4785Z",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterWhite);
export default __webpack_public_path__ + "static/media/PrinterWhite.9403f94fb70a040b1d44661d28c0be96.svg";
export { ForwardRef as ReactComponent };